import { AudioChannel, AudioSettingsScope } from "../types";

const STORAGE_PREFIX = "flownect.audioSettings";

type GetAudioPreferenceKeyParams = {
  channel: AudioChannel;
  scope: AudioSettingsScope;
  companyId?: number | string | null;
  accountId?: number | string | null;
};

export const getAudioPreferenceKey = ({ channel, scope, companyId, accountId }: GetAudioPreferenceKeyParams): string => {
  const ownerId = scope === "company" ? companyId ?? "active-company" : accountId ?? "current-account";

  return `${STORAGE_PREFIX}.${scope}.${ownerId}.${channel}`;
};
